import { Reference } from '../types';
import { getEntityCollectionActions } from './actions';
import { createHydratedEntityState, getEntityDataAdapter } from './data';
import { getEntityMetaAdapter } from './meta-adapter';
import { getSelectors } from './selectors';
import { BaseEntity, BaseSelector, DEFAULT_SCOPE_NAME, EntityState, IdSelector } from './types';

export const entityInitialState: EntityState<any> = Object.freeze({
  aliases: {},
  entityMap: {},
  entityMetaMap: {},
  scope: {
    [DEFAULT_SCOPE_NAME]: [],
  },
  scopeMeta: {
    [DEFAULT_SCOPE_NAME]: {
      loaded: false,
      pending: false,
      failed: false,
      error: null,
    },
  },
  optimisticUpdate: {},
  optimisticDelete: {},
  scopePagination: {
    [DEFAULT_SCOPE_NAME]: {
      limit: null,
      page: null,
      totalCount: null,
    },
  },
});

export const createEntityAdapter = <T extends BaseEntity, U extends IdSelector<T>, T1 = Partial<T>>(
  baseSelector: BaseSelector<T>,
  namespace: string,
  selectId: U,
  references?: Reference<T>[],
  initialCollection: T[] = [],
) => {
  const entityDataAdapter = getEntityDataAdapter<T>(selectId, entityInitialState);
  const entityMetaAdapter = getEntityMetaAdapter<T>();
  const entityAdapter = { ...entityMetaAdapter, ...entityDataAdapter };
  const selectors = getSelectors<T>(baseSelector, namespace, references || null);
  const actions = getEntityCollectionActions<T, T1, U>(entityAdapter, selectId);

  return {
    selectors,
    adapter: entityAdapter,
    defaultActions: actions,
    initialState: createHydratedEntityState<T>(
      entityInitialState,
      initialCollection,
      entityAdapter,
    ),
  };
};
